/* eslint-disable no-new-func */
import { RecursivePartial } from 'typings/utilsTypes';
import useFormulaStore from '../stores/useFormulaStore';
import { VirtualFormulaResponse } from '../types/api/formula';

export const getFormula = (): RecursivePartial<VirtualFormulaResponse> =>
  useFormulaStore.getState().formula;

export const getBuyLot = (lot: number, price: number): number => {
  const { buy } = getFormula();

  return new Function(`LOT=${lot},PRICE=${price}`, `return ${buy?.lot}`)();
};

export const getSellLot = (lot: number, price: number): number => {
  const { sell } = getFormula();

  return new Function(`LOT=${lot},PRICE=${price}`, `return ${sell?.lot}`)();
};

export const getSellProfitLoss = (
  lot: number,
  price: number,
  buyAmount: number,
): number => {
  const { sell } = getFormula();

  return Function(
    `LOT=${lot},PRICE=${price},BUYAMOUNT=${buyAmount}`,
    `return ${sell?.profit_loss}`,
  )();
};

export const getSellGain = (
  sellProfitLoss: number,
  buyAmount: number,
): number => {
  const { sell } = getFormula();

  return Function(
    `SELL_PROFITLOSS=${sellProfitLoss},BUYAMOUNT=${buyAmount}`,
    `return ${sell?.gain}`,
  )();
};
